import { render, staticRenderFns } from "./AccountsListFooter.vue?vue&type=template&id=29066a73"
import script from "./AccountsListFooter.vue?vue&type=script&lang=js"
export * from "./AccountsListFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports